import { render, staticRenderFns } from "./CustomUISettings.vue?vue&type=template&id=6e9efe7e"
import script from "./CustomUISettings.vue?vue&type=script&lang=ts"
export * from "./CustomUISettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports